module.exports = __webpack_public_path__ + "static/media/parking-concept-new.866e610f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/parking-concept-new.png
// module id = 71
// module chunks = 0